import { Card, Grid, Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { useEffect, useState } from 'react';
import Headers from './Header/Headers';
import MenuSideBars from './SideBar/MenuSideBars';

function MainLayout({ children }) {
    const screens = Grid.useBreakpoint();
    const isMobileOrTablet = !screens.lg;
    const [collapsed, setCollapsed] = useState(isMobileOrTablet);

    useEffect(() => {
        setCollapsed(isMobileOrTablet);
    }, [isMobileOrTablet]);

    return (
        <Layout className="app-shell">
            <Headers
                showMenuButton={isMobileOrTablet}
                onMenuClick={() => setCollapsed((value) => !value)}
            />
            <Layout className="app-body">
                <MenuSideBars
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    isMobileOrTablet={isMobileOrTablet}
                />
                <Layout className="app-main-layout">
                    <Content className="app-content">
                        <Card className="app-content-card">
                            {children}
                        </Card>
                    </Content>
                </Layout>
            </Layout>
            {/* <Footers /> */}
        </Layout>
    );
}

export default MainLayout;
